import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FOOTER_COLUMNS, LOGO_URL, SOCIAL_LINKS } from './data';

const PRIVACIDADE_IMG_URL = 'https://static.readdy.ai/image/22e92c18f0b031d861a5e53bf8e362fb/c6588d0b1f2b20a048ea2e4f0b7b5a96.png';
const SEGURANCA_IMG_URL = 'https://static.readdy.ai/image/22e92c18f0b031d861a5e53bf8e362fb/42eccd564fc97d67e13d9de2047cbd71.png';

type DocumentoKey = 'privacidade' | 'seguranca';

export default function LandingFooter() {
  const navigate = useNavigate();
  const [documentoAberto, setDocumentoAberto] = useState<DocumentoKey | null>(null);

  const handleLink = (target: string) => (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (target.startsWith('#')) {
      event.preventDefault();
      const el = document.querySelector(target);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    if (target.startsWith('/')) {
      event.preventDefault();
      navigate(target);
    }
  };

  return (
    <footer className="bg-primary-600 pb-10 pt-16 text-background-100">
      <div className="mx-auto w-full max-w-[1240px] px-6">
        <div className="grid gap-10 border-b border-white/10 pb-12 lg:grid-cols-12">
          <div className="lg:col-span-6">
            <img src={LOGO_URL} alt="GetPoints" className="logo-glow h-11 w-auto" />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-background-100">
              Plataforma de incentivo, premiação e gamificação para times comerciais. Mais engajamento, mais execução, mais resultado.
            </p>
            <div className="mt-6 flex gap-3">
              {SOCIAL_LINKS.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  className="flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-background-100 transition-colors hover:bg-white/20"
                >
                  <i className={`${social.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          {FOOTER_COLUMNS.map((column) => (
            <div key={column.title} className="lg:col-span-2">
              <h4 className="font-heading text-sm font-bold uppercase tracking-wider text-background-50">{column.title}</h4>
              <ul className="mt-5 space-y-3">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.target.startsWith('#') ? link.target : link.target}
                      onClick={handleLink(link.target)}
                      rel={link.target.startsWith('http') ? 'nofollow noopener' : undefined}
                      className="text-sm text-background-100 transition-colors hover:text-background-50"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="flex flex-col items-start justify-between gap-4 pt-8 text-sm text-background-200 md:flex-row md:items-center">
          <p>Copyright © {new Date().getFullYear()} GetPoints Tecnologia Ltda. Todos os direitos reservados.</p>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
            <a href="#faq" onClick={handleLink('#faq')} className="whitespace-nowrap transition-colors hover:text-background-50">
              Termos e Condições de Uso Empresa
            </a>
            <a href="#faq" onClick={handleLink('#faq')} className="whitespace-nowrap transition-colors hover:text-background-50">
              Termos e Condições de Uso Usuário
            </a>
            <button
              type="button"
              onClick={() => setDocumentoAberto('seguranca')}
              className="cursor-pointer whitespace-nowrap transition-colors hover:text-background-50"
            >
              Política de Segurança de Dados
            </button>
            <button
              type="button"
              onClick={() => setDocumentoAberto('privacidade')}
              className="cursor-pointer whitespace-nowrap transition-colors hover:text-background-50"
            >
              Política de Privacidade
            </button>
          </div>
        </div>
      </div>

      {documentoAberto && (
        <div
          className="fixed inset-0 z-[80] flex items-center justify-center bg-black/70 p-4"
          onClick={() => setDocumentoAberto(null)}
        >
          <div
            className="relative max-h-[90vh] w-full max-w-3xl overflow-hidden rounded-lg bg-background-50"
            onClick={(event) => event.stopPropagation()}
          >
            <button
              type="button"
              onClick={() => setDocumentoAberto(null)}
              aria-label="Fechar"
              className="absolute right-3 top-3 z-10 flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-black/60 text-white transition-colors hover:bg-black/80"
            >
              <i className="ri-close-line text-xl"></i>
            </button>
            <div className="max-h-[90vh] overflow-y-auto">
              <img
                src={documentoAberto === 'privacidade' ? PRIVACIDADE_IMG_URL : SEGURANCA_IMG_URL}
                alt={
                  documentoAberto === 'privacidade'
                    ? 'Política de Privacidade e Proteção de Dados Pessoais - GetPoints'
                    : 'Política de Segurança de Dados - GetPoints'
                }
                title={
                  documentoAberto === 'privacidade'
                    ? 'Política de Privacidade GetPoints'
                    : 'Política de Segurança de Dados GetPoints'
                }
                className="h-auto w-full object-top"
              />
            </div>
          </div>
        </div>
      )}
    </footer>
  );
}